import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Heading from '../../generic-components/Heading';
import Button from '../../generic-components/Button';
import Icon from '../../generic-components/Icon';
import { DownArrow, download } from '../../assets/svg';
import { handleDownload, printIframe } from '../../services/general.service';

interface IProps {
  srcLink: string;
}

const HEADER_STYLES = {
  WRAPPER_HEADER: 'py-[16px] pl-[24px] pr-[16px] border-b-[0.8px] border-bw03 flex items-center justify-between',
  TITLE: 'font-metricR text-bw08 text-[20px]',
  BUTTON_WRAPPER: 'p-0.5 border-[1px] border-bw03 rounded-[5px] relative bg-[#fff]',
  DOWNLOAD_AND_PRINT:
    'min-w-[184px] justify-center rounded-[5px] py-[6px] pl-[10px] pr-[8px] font-metricR text-bw08 text-[16px] flex-row-reverse flex cursor-pointer hover:bg-bw03',
  DOWNLOAD_OPTIONS_WRAPPER: 'absolute top-[42px] left-0 bg-[#fff] p-0.5 border-[1px] border-bw03 rounded-[5px]',
  DOWNLOAD_SUB_BUTTON:
    'bg-[#fff] min-w-[184px] rounded-t-[4px] py-[9px] pl-[10px] pr-[8px] font-metricR text-bw08 text-[14px] flex flex-start cursor-pointer hover:bg-bw03 bg-bw00',
  PRINT_SUB_BUTTON:
    'bg-[#fff] min-w-[184px] rounded-b-[4px] py-[9px] pl-[10px] pr-[8px] font-metricR text-bw08 text-[14px] flex flex-start cursor-pointer hover:bg-bw03 bg-bw00',
};
export const Header = ({ srcLink }: IProps) => {
  const [showDownloadOptions, setShowDownloadOptions] = useState<boolean>(false);
  const { t } = useTranslation();

  const handleToggleDropdown = () => {
    setShowDownloadOptions((prevState) => !prevState);
  };

  return (
    <div className={HEADER_STYLES.WRAPPER_HEADER}>
      <Heading className={HEADER_STYLES.TITLE} id='RoutingNumberChange' title='Routing Number Change' />
      <div className={HEADER_STYLES.BUTTON_WRAPPER}>
        <Button
          id='downloadAndPrint'
          childElement={
            <div className='flex items-center justify-between w-full'>
              <Icon className='w-[20px] h-[20px] mb-[3px] mr-[2px]' src={download} />
              <Heading title={t('ROUTING_NUMBER.DOWNLOAD_AND_PRINT')} className='' />
              <Icon className='mr-[2px]' src={DownArrow} rotated={showDownloadOptions} />
            </div>
          }
          className={HEADER_STYLES.DOWNLOAD_AND_PRINT}
          onClick={() => handleToggleDropdown()}
        />
        {showDownloadOptions && (
          <div className={HEADER_STYLES.DOWNLOAD_OPTIONS_WRAPPER}>
            <Button
              id='download_option'
              title={t('ROUTING_NUMBER.DOWNLOAD_OPTION')}
              className={HEADER_STYLES.DOWNLOAD_SUB_BUTTON}
              onClick={() => {
                handleDownload(srcLink, 'Routing Number Change');
                setShowDownloadOptions((prevState: boolean) => !prevState);
              }}
            />
            <Button
              id='print_option'
              title={t('ROUTING_NUMBER.PRINT_OPTION')}
              className={HEADER_STYLES.PRINT_SUB_BUTTON}
              onClick={() => {
                printIframe('report');
                setShowDownloadOptions((prevState: boolean) => !prevState);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
